import React from 'react';
import { createComponentPreviewEntry } from '@wix/editor-elements-integrations';
import { usePreviewState } from '@wix/editor-elements-preview-utils';
import type { IComponentPreviewWrapper } from '@wix/editor-elements-types/thunderboltPreview';
import type { PreviewTooltipProps } from '@wix/thunderbolt-becky-types';

import type { ILoginSocialBarProps } from '../LoginSocialBar.types';

import menuStyles from './loginSocialBar/components/loginSocialBarCustomMenu/LoginSocialBarCustomMenu.module.scss';
import loggedInStyles from './loginSocialBar/components/loggedInSocialBar/LoggedInSocialBar.module.scss';
import loggedOffStyles from './loginSocialBar/components/loggedOffSocialBar/LoggedOffSocialBar.module.scss';

function withComponentPreview(
  WrappedComponent: React.ComponentType<
    ILoginSocialBarProps & PreviewTooltipProps
  >,
): IComponentPreviewWrapper<ILoginSocialBarProps & PreviewTooltipProps> {
  return ({ previewWrapperProps = {}, ...viewerProps }) => {
    const { compPreviewState } = previewWrapperProps;

    const linkSelector = menuStyles.link;
    const loggedInUserSelector = loggedInStyles.user;
    const loginSelector = loggedOffStyles.login;

    usePreviewState(viewerProps.id, compPreviewState, {
      'loggedInMenuOpened selected': {
        selectors: `.${linkSelector}`,
        type: 'plural',
      },
      'loggedInMenuOpened hover': {
        selectors: [
          `.${loggedInUserSelector}`,
          `.${loginSelector}`,
          `.${linkSelector}`,
        ],
        type: 'plural',
      },
    });

    const onLogout = (event: React.MouseEvent<Element, MouseEvent>) => {
      event.stopPropagation();
      viewerProps.showTooltip(
        event.currentTarget.getBoundingClientRect(),
        'PREVIEW_TOOLTIP_GOTO_LIVE_SITE',
        {},
      );
    };

    return (
      <WrappedComponent
        {...viewerProps}
        onLogout={onLogout}
        onBlur={() => {}}
      />
    );
  };
}

export default (
  ViewerComponent: React.ComponentType<
    ILoginSocialBarProps & PreviewTooltipProps
  >,
) => createComponentPreviewEntry(withComponentPreview(ViewerComponent));
